import { Outlet } from "react-router-dom";
import './Layout.scss';
import '../assets/scss/style.scss';

const LayoutBasic = () => {


    return (
    <>
      <div className="wrapper">
        <div className="container">
          <Outlet />
        </div>
      </div>
    </>
  )
};

export default LayoutBasic;